import { render, staticRenderFns } from "./AddCardPopup.vue?vue&type=template&id=55c72028"
import script from "./AddCardPopup.vue?vue&type=script&lang=js"
export * from "./AddCardPopup.vue?vue&type=script&lang=js"
import style0 from "./AddCardPopup.vue?vue&type=style&index=0&id=55c72028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports